import Amazon from './Amazon'
export default Amazon